// extracted by mini-css-extract-plugin
module.exports = {"container":"_3_fVN","slide":"_2-p9-","postWrapper":"_2Nzfa","separator":"_3ShwT"};